import React, {useCallback, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Card, CardBody, Col, Container, Row,} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {clearBrokers, getBrokers, modalBroker} from "../../store/brokers/actions";
import {useTranslation} from "react-i18next";
import TableBroker from "./components/TableBroker";
import NoSearchResult from "../../components/Common/NoSearchResult";
import ModalBroker from "./components/ModalBroker"
import usePermissions from "src/hooks/usePermissions";
import ServerPagination from "../../components/Common/ServerPagination";

const Brokers = () => {
    document.title = "Broker List | Dashboard";
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {hasPermission} = usePermissions();
    const navigate = useNavigate();

    const data = useSelector((state: any) => state.Brokers.data || []);
    const pagination = useSelector((state: any) => state.Brokers.pagination || {});
    const loading = useSelector((state: any) => state.Brokers.loading || false);
    const isOpenModal = useSelector((state: any) => state.Brokers.isOpenModal || false);

    const [filter, setFilter] = useState({per_page: 10, page: 1, sort_key: "id", sort_order: "desc", q: ""});

    const updateFilter = useCallback((changes: Partial<typeof filter>) => {
        setFilter((prevFilter) => ({...prevFilter, ...changes}));
    }, [setFilter]);

    const handlePageSizeChange = useCallback((newPageSize: number) => updateFilter({
        per_page: newPageSize,
        page: 1
    }), [updateFilter])

    const handlePageChange = useCallback((newPage: number) => updateFilter({page: newPage}), [updateFilter])

    const handleSearchChange = useCallback((search: string) => {
        if (!search && !filter.q) return
        updateFilter({q: search, page: 1})
    }, [filter.q, updateFilter])

    const handleSortChange = useCallback((sortKey?: string, sortOrder?: string) => {
        updateFilter({sort_key: sortKey, sort_order: sortOrder, page: 1})
    }, [updateFilter])

    useEffect(() => {
        dispatch(getBrokers('', filter))

        return () => {
            dispatch(clearBrokers())
        };
    }, [dispatch, filter]);

    const handleBrokerClicks = () => {
        dispatch(modalBroker(true))
    };

    useEffect(() => {
        const permission = hasPermission('view-brokers');
        if (!permission) {
            navigate('/no-access');
        }
    }, [hasPermission, navigate]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Brokers"/>

                    <Row className="align-items-center">
                        <Col md={12}>
                            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                                <div>
                                    {
                                        hasPermission("create-brokers") &&
                                        <Link to="#" className="btn btn-light" onClick={handleBrokerClicks}>
                                            <i className="bx bx-plus me-1"></i> Add New
                                        </Link>
                                    }
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <Card>
                                <CardBody className="border-bottom">
                                    <TableBroker
                                        data={data}
                                        pageSize={filter.per_page}
                                        onPageSizeChange={handlePageSizeChange}
                                        onSearchChange={handleSearchChange}
                                        onSortChange={handleSortChange}/>

                                    {!loading && data.length === 0 && (<NoSearchResult/>)}
                                    {loading && (<NoSearchResult text="Loading..."/>)}

                                    {pagination.total_page > 1 && (
                                        <ServerPagination
                                            totalPages={pagination.total_page}
                                            page={pagination.current_page}
                                            onChange={handlePageChange}
                                            className="mt-2"/>
                                    )}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>


                    {isOpenModal && <ModalBroker isOpen={isOpenModal}/>}
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Brokers;